import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MsalService } from "@azure/msal-angular";

// auth-callback.component.ts
@Component({ template: 'Processing login...' })
export class AuthCallbackComponent implements OnInit {
  constructor(
    private msalService: MsalService,
    private router: Router
  ) {}

  ngOnInit() {
    this.msalService.handleRedirectObservable().subscribe({
      complete: () => {
        // Notify parent
        window.parent.postMessage('AUTH_COMPLETE', 'https://rosnyc.com');
        this.router.navigate(['/dashboard']);
      },
      error: (err) => console.error('Auth failed:', err)
    });
  }
}